import { BigNum, TWO } from '@drift-labs/sdk';
import {
	HIGHEST_LEAGUE_CONFIG,
	LEAGUE_LIST,
	UNRANKED_LEAGUE_CONFIG,
} from 'src/constants/points';

export const printPoints = (points: number | null, millified = false) => {
	if (points === null) return '0';

	if (points < 10) return BigNum.from(points * 100, TWO).prettyPrint(); // show decimals for numbers less than 10

	if (millified) {
		return BigNum.from(points).toMillified();
	}

	return BigNum.from(points).prettyPrint();
};

export const getLeagueConfigFromVolume = (volume: number | null) => {
	if (volume === null) return UNRANKED_LEAGUE_CONFIG;

	const leagueConfig = LEAGUE_LIST.reduce((curr, leagueConfig) => {
		if (
			volume >= leagueConfig.rangeStart &&
			leagueConfig.rangeStart >= curr.rangeStart
		) {
			return leagueConfig;
		}

		return curr;
	}, UNRANKED_LEAGUE_CONFIG);

	return leagueConfig;
};

export const getNextLeagueConfig = (volume: number | null) => {
	const currentLeagueConfig = getLeagueConfigFromVolume(volume);

	if (currentLeagueConfig.league === HIGHEST_LEAGUE_CONFIG.league) {
		return HIGHEST_LEAGUE_CONFIG;
	}

	const allLeaguesAboveCurrentLeague = LEAGUE_LIST.filter(
		(league) => league.rangeStart > currentLeagueConfig.rangeStart
	);
	const nextLeagueConfig = allLeaguesAboveCurrentLeague.reduce(
		(curr, leagueConfig) => {
			if (leagueConfig.rangeStart < curr.rangeStart) {
				return leagueConfig;
			}

			return curr;
		},
		allLeaguesAboveCurrentLeague[0]
	);

	return nextLeagueConfig;
};
